import { cn } from '@/lib/utils';

// A minimal ticking analog clock SVG. Used as the "auto-detecting timezone"
// loading indicator in LocationFormModal — stays on-theme vs. a generic
// spinner. The minute hand ticks once per second via a global @keyframes
// rule defined in index.css (th-clock-tick).
export function TickingClock({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('h-4 w-4', className)}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      {/* Hour hand — thicker/shorter so it reads as a clock at 16px. */}
      <line x1="12" y1="12" x2="12" y2="7" strokeWidth="2.5" />
      {/* Minute hand — ticks in 1-second steps via global keyframes. */}
      <line
        x1="12"
        y1="12"
        x2="17"
        y2="12"
        style={{
          transformOrigin: '12px 12px',
          animation: 'th-clock-tick 12s steps(12, end) infinite',
        }}
      />
    </svg>
  );
}
